import Description from '../components/Description/Description';
import StatusWrapper from '../components/StatusWrapper/StatusWrapper';
import StatusTimer from '../components/StatusTimer/StatusTimer';
import { useLanguageContext } from '../core/locale/LanguageContext';
import type { StatusViewChildProps } from './StatusView.types';

const StatusViewLegacy = ({
  phoneNumber,
  expiresAt,
  startTime,
}: StatusViewChildProps): React.ReactNode => {
  const languageContext = useLanguageContext();

  return (
    <StatusWrapper>
      <h1>{languageContext.getLocalizedText('statusHeader')}</h1>
      <StatusTimer expiresAt={expiresAt} startTime={startTime} />
      <Description lines={[languageContext.getLocalizedText('statusContent', phoneNumber)]} />
    </StatusWrapper>
  );
};

export default StatusViewLegacy;
